import React, { useEffect, useRef } from "react";
import './HeroSection.css'

const HeroSection = () => {


  const parentRef = useRef(null);
  const childRef = useRef(null);
  const imgRef = useRef(null);

useEffect(() => {
  const img = imgRef.current;
  const child = childRef.current;

  if (!img || !child) return;

  child.style.transform = "translate(-50%, 0%)";
  img.style.opacity = "1";
  img.style.display = "block";
}, []);


  useEffect(() => {

    const handleScroll = () => {

      const section = parentRef.current;
      const child = childRef.current;
      const img = imgRef.current;

      if (!section || !child) return;

      const rect = section.getBoundingClientRect();

      const progress = Math.min(
        Math.max(-rect.top / rect.height, 0),
        1
      );


child.style.transform =
  `translate(-50%, ${-progress * 100}%)`;

img.style.transform = 
`scale(${1 + progress * 0.5}) `;

img.style.opacity = `${1 - progress/ 0.8}`

};



    window.addEventListener("scroll", handleScroll);

    return () =>
      window.removeEventListener("scroll", handleScroll);

  }, []);

  return (
    <div className='hero-section-container' ref= {parentRef}>

<div className="hero-content">
  <h1>Find Your Dream Home </h1>
  <button><a href="/for-sale">Find Properties <i class="ri-arrow-right-long-line"></i></a></button>
</div>


      <div className="hero-sticky-wrapper">
      <div className="hero-section-overlap-image-container" ref= {childRef}>
     <img className = 'hero-section-overlap-image' src="/images/house.png" alt=""  ref= {imgRef}/>
    </div>
    </div>
    </div>
  )
}

export default HeroSection